module.exports = __webpack_public_path__ + "fondo_home.9149758e3948e2d86395.png";


//////////////////
// WEBPACK FOOTER
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/assets/images/fondo_home.png
// module id = ../../../../../src/assets/images/fondo_home.png
// module chunks = 1